import { useEffect, useRef, useState } from 'react';
import { Terminal } from 'xterm';
import { FitAddon } from 'xterm-addon-fit';
import 'xterm/css/xterm.css';
import { getWsUrl, getServerToken } from '../api';
import { useStore } from '../store';
import { Badge } from '../ui';

// Terminal palitrasi qattiq kodlanmaydi — kit tokenlaridan o'qiladi,
// shuning uchun kunduzgi/tungi mavzuda terminal ham tizim bilan birga o'zgaradi.
function readToken(name, fallback) {
  if (typeof window === 'undefined') return fallback;
  const v = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
  return v || fallback;
}

function buildTermTheme() {
  return {
    background:  readToken('--ui-surface-2', '#18181b'),
    foreground:  readToken('--ui-text-1', '#fafafa'),
    cursor:      readToken('--ui-text-1', '#fafafa'),
    cursorAccent: readToken('--ui-surface-2', '#18181b'),
    red:         readToken('--ui-st-critical', '#f87171'),
    brightRed:   readToken('--ui-st-critical', '#f87171'),
    green:       readToken('--ui-st-ok', '#4ade80'),
    brightGreen: readToken('--ui-st-ok', '#4ade80'),
    yellow:      readToken('--ui-st-medium', '#facc15'),
    brightYellow: readToken('--ui-st-medium', '#facc15'),
    white:       readToken('--ui-text-1', '#fafafa'),
    brightBlack: readToken('--ui-text-3', '#8b8b93'),
  };
}

export default function WebTerminal() {
  const terminalRef = useRef(null);
  const socketRef = useRef(null);
  const termInstanceRef = useRef(null);
  const fitAddonRef = useRef(null);
  const [connected, setConnected] = useState(false);
  const { theme } = useStore();

  useEffect(() => {
    if (!terminalRef.current) return;

    // Initialize xterm
    const term = new Terminal({
      cursorBlink: true,
      fontFamily: readToken('--ui-mono', 'ui-monospace, Menlo, Consolas, monospace'),
      fontSize: 13,
      theme: buildTermTheme(),
    });
    termInstanceRef.current = term;

    const fitAddon = new FitAddon();
    fitAddonRef.current = fitAddon;
    term.loadAddon(fitAddon);
    
    term.open(terminalRef.current);
    fitAddon.fit();

    term.writeln('\x1b[33mConnecting to VPS...\x1b[0m');

    // Server sessiya tokeni (2FA bilan olingan). Oddiy access token YARAMAYDI.
    const token = getServerToken();
    if (!token) {
      term.writeln('\x1b[31mServer sessiyasi yo\'q. 2FA kodi bilan sessiyani oching.\x1b[0m');
      return;
    }

    // Token URL'ga QO'YILMAYDI (nginx loglariga tushmasligi uchun) —
    // ulangach birinchi xabar sifatida yuboriladi.
    const wsUrl = getWsUrl('/server/terminal');
    const ws = new WebSocket(wsUrl);
    socketRef.current = ws;

    ws.onopen = () => {
      ws.send(`auth:${token}`);
      setConnected(true);
      term.writeln('\x1b[32mConnected successfully.\x1b[0m\r\n');

      term.onData((data) => {
        if (ws.readyState === WebSocket.OPEN) {
          ws.send(data);
        }
      });
    };

    ws.onmessage = (event) => {
      term.write(event.data);
    };

    ws.onerror = () => {
      term.writeln('\r\n\x1b[31mWebSocket error occurred.\x1b[0m');
    };

    ws.onclose = () => {
      setConnected(false);
      term.writeln('\r\n\x1b[31mConnection closed.\x1b[0m');
    };

    const resizeObserver = new ResizeObserver(() => {
      try {
        fitAddon.fit();
      } catch (e) {
        // ignore
      }
    });
    resizeObserver.observe(terminalRef.current);

    return () => {
      resizeObserver.disconnect();
      ws.close();
      term.dispose();
    };
  }, []);

  // Mavzu almashsa — terminal palitrasi ham tokenlar bilan birga yangilanadi.
  useEffect(() => {
    const term = termInstanceRef.current;
    if (!term) return;
    // requestAnimationFrame: yangi mavzu tokenlari DOM'ga tushib bo'lgach o'qiymiz
    const id = requestAnimationFrame(() => {
      try { term.options.theme = buildTermTheme() } catch { /* eski xterm API */ }
    });
    return () => cancelAnimationFrame(id);
  }, [theme]);

  return (
    <div className="card" style={{ padding: 16, borderRadius: 8, border: '1px solid var(--ui-border)', background: 'var(--ui-surface)' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <h3 style={{ margin: 0, fontSize: 18, fontWeight: 600, color: 'var(--ui-text-1)' }}>Linux Terminal (VPS)</h3>
        <Badge tone={connected ? 'ok' : 'critical'}>
          {connected ? 'Ulangan' : 'Uzilgan'}
        </Badge>
      </div>
      <div
        ref={terminalRef}
        style={{
          height: '60vh',
          width: '100%',
          borderRadius: 6,
          border: '1px solid var(--ui-border)',
          overflow: 'hidden',
          padding: 8,
          background: 'var(--ui-surface-2)'
        }}
      />
    </div>
  );
}
